{
  "email": "Email",
  "emailAddress": "Email Address",
  "emailAddressPlaceholder": "Enter Your Email Address",
  "continue": "Continue",
  "send": "Send",
  "resend": "Resend",
  "sendCodeErrorTip": "Failed to send code: {error}",
  "sendEmailTips": "We have sent a verification code to your email",
  "verificationCode": "Verification Code",
  "codePlaceholder": "Enter the code",
  "wallet": "Wallet",
  "otherLoginMethods": "Other login methods",
  "login": "Login",
  "user": "User",
  "loginTitle": "Log in / Sign up",
  "loginTips": "You can use the following methods",
  "passwordMinError": "Password must be at least {length} characters",
  "passwordMatchError": "The password you entered twice do not match",
  "passwordTitle": "Set Password",
  "passwordTips": "Please set the wallet password that will be used to recover the wallet",
  "password": "Password",
  "passwordPlaceholder": "Enter Your Password",
  "rePassword": "Re Password",
  "rePasswordPlaceholder": "Re Enter the Password",
  "recoverTitle": "Recover Wallet",
  "recoverTips": "Please enter your password to recover your wallet",
  "bindWith": "Bind with {name} Wallet",
  "loginWith": "Login with {name} Wallet",
  "editUsernameTitle": "Edit User Name",
  "setUsernameTitle": "Set User Name",
  "username": "User Name",
  "usernamePlaceholder": "Enter Your User Name",
  "usernameValidError": "Name can be composed of numbers and letters as well as characters",
  "usernameLengthError": "No less than 2 characters",
  "confirm": "Confirm",
  "nextTime": "Next time",
  "setUsername": "Set a User Name",
  "disconnect": "Disconnect",
  "CEXBindTitle": "Bind {type} API",
  "CEXBindAttention": "Attention:",
  "CEXBindTips1": "1. Please bind the API for read-only permissions.",
  "CEXBindTips2": "2. Your API may be out of date, it is better to use a long term API.",
  "CEXBindTips3": "3. Only one API can be bound to the same exchange at the same time.",
  "CEXBindApiKey": "API Key",
  "CEXBindApiSecretKey": "API Secret Key",
  "CEXBindApiPassphrase": "API Passphrase",
  "cancel": "Cancel",
  "walletLoading": "Wallet service is loading",
  "tokenDetails": "Token Details",
  "tokenAmountMin": "Amount must be greater than 0.",
  "tokenAmountMax": "Insufficient balance.",
  "tokenAddressError": "Invalid address.",
  "amount": "Amount",
  "amountPlaceholder": "Enter the Amount.",
  "balance": "Balance",
  "receiveTitle": "Received wallet address",
  "receivePlaceholder": "Enter the Receiving wallet address.",
  "next": "Next",
  "copied": "Copied",
  "receiveQrcode": "Receive by scanning the QR code",
  "copyAddress": "Copy Address",
  "tokenSmartContract": "Token Smart Contract",
  "tokenSmartContractPlaceholder": "Enter the Token Smart Contract.",
  "tokenSymbol": "Token Symbol",
  "tokenSymbolPlaceholder": "Enter the Token Symbol.",
  "tokenDecimals": "Decimals",
  "tokenDecimalsPlaceholder": "Enter the Decimals.",
  "import": "Import",
  "receive": "Receive",
  "customizedToken": "Customized Token",
  "noMoreRecords": "There is no more Records here!",
  "noRecords": "No Records here!",
  "close": "Close",
  "back": "Back",
  "importSuccess": "Import Token Successfully",
  "importFail": "Failed to import Token",
  "changeNetwork": "Change Network",
  "approveSuccess": "Approve Successfully",
  "Approve": "Approve",
  "noFriends": "No Friends yet",
  "noRequests": "No Requests yet",
  "noMore": "No more",
  "Remove": "Remove",
  "removeSuccess": "Remove Successfully"
}